// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {buildCurrency} from '../../../shared/services/build-number';
import {create as createHashMap} from '../../../shared/services/hashmap';

const LaborRates = props => {

    const initialState = createHashMap(props.selectedDealers, 'account');
    const uid = 'account';

    // Check if all dealers are selected by comparing lengths

    const allSelected = props.selectedDealers.length === props.laborRates.length && props.laborRates.length > 0;

    function handleSelectAllCheckboxChange() {

        if (props.actions.toggleSelectAllRecords) {

            props.actions.toggleSelectAllRecords(props.laborRates, allSelected);

        }

    }

    function handleDealerChange(laborRate, account, isSelected) {

        props.actions.updateSelectedDealer(laborRate, isSelected);

    }

    return (
        <section className='labor-rates'>
            <table className='table-structure'>
                <tr>
                    <th>
                        <Checkbox
                            id='select-all-checkbox'
                            onChange={handleSelectAllCheckboxChange}
                            selected={allSelected}
                        >
                            <FormattedMessage id='SELECT'/>
                        </Checkbox>
                    </th>
                    <th><FormattedMessage id='DEALER_LOCATION'/></th>
                    <th colSpan={props.laborRates[0].rates.length}><FormattedMessage id='OLD_LABOR_RATE'/></th>
                    <th colSpan={props.laborRates[0].rates.length}><FormattedMessage id='NEW_LABOR_RATE'/></th>
                </tr>
                <tr>
                    <th></th>
                    <th></th>

                    {props.laborRates[0].rates.map((rate, index) => <th key={index}> <FormattedMessage id={rate.description}/></th>)}
                    {props.laborRates[0].rates.map((rate, index) => <th key={index}> <FormattedMessage id={rate.description}/></th>)}
                </tr>
                {props.laborRates.map(laborRate =>
                    <tr
                        className='table-data'
                        key={laborRate.account}
                    >
                        <td>
                            <Checkbox
                                id={laborRate.account}
                                onChange={handleDealerChange.bind(this, laborRate)}
                                selected={allSelected || initialState[laborRate[uid]] || false}
                            >
                                {}
                            </Checkbox>
                        </td>
                        <td>{laborRate.account}</td>
                        {laborRate.rates.map((rate, key) =>
                            <td
                                className={rate.isRateDifferenceLarge ? 'warning-font-color' : ''}
                                key={key}
                            >
                                {buildCurrency(rate.currentRate)}
                            </td>)}
                        {laborRate.rates.map((rate, key) =>
                            <td
                                className={rate.isRateDifferenceLarge ? 'warning-font-color' : ''}
                                key={key}
                            >
                                {buildCurrency(rate.requestedRate)}
                            </td>)}
                    </tr>)}
            </table>
        </section>

    );

};

LaborRates.displayName = 'LaborRates';
LaborRates.propTypes = {
    actions: PropTypes.object.isRequired,
    allSelected: PropTypes.bool,
    laborRates: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired
};

export default LaborRates;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/components/labor-rates.js